import React, { useEffect } from 'react';
import { useFormikContext } from "formik";
import ChoiceGroup from '../../../Forms/ChoiceGroup';
import ComboBox from '../../../Forms/ComboBox';
import DateTimePicker from '../../../Forms/DateTimePicker';
import { statusOptions, statusTextMap, timezoneOptions } from '../Helpers/CopyAndFunctions';

const PublishStatusFields = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        const statusText = statusTextMap[values.publishStatusId] || '';
        setFieldValue('publishStatus', statusText);
    }, [values.publishStatusId, setFieldValue])
  
  return (
    <>
        <ChoiceGroup
            label="Status"
            name="publishStatusId"
            options={statusOptions}
            required
        />
        <hr />
        <DateTimePicker
            name='webinarDateTime'
            label='Webinar Date & Time (in the selected timezone)'
            datetime={
                values.webinarDateTime
                ? new Date(values.webinarDateTime)
                : new Date()
            }
            setDateTime={(date) => setFieldValue("webinarDateTime", date)}
            required
        />
        <ComboBox
            name='dateTimeOffset'
            label='Timezone (DateTime Offset)'
            options={timezoneOptions}
            placeholder='Select'
            required
        />
    </>
  );
};

export default PublishStatusFields;
